import { combineReducers } from 'redux'
import { inUseReducerFactory } from '../../../restux/ui'
import { medicalEventFilesConfig, MedicalEventFilesState } from './medicalEventFiles.model'

const inUse = inUseReducerFactory(medicalEventFilesConfig)

export const medicalEventFilesReducer = combineReducers<MedicalEventFilesState>({
  inUse,
})
